<template>
  <v-row class="ma-0" justify="center">
    <v-col cols="12" sm="9" md="6" lg="5" xl="4">
      <PaymentStatus
        :userId="$route.params.userId"
        :orderId="$route.params.orderId"
        :title="title"
        :message="message"
        :positiveBtnText="positiveBtnText"
        :negativeBtnText="negativeBtnText"
        @change="onStatusChange"
        @positive-btn-click="onPositiveBtnClick"
        @negative-btn-click="onNegativeBtnClick"
      ></PaymentStatus>
    </v-col>
  </v-row>
</template>

<script>
import PaymentStatus from '@/components/generalComponents/PaymentStatus';

export default {
  name: 'SubscriptionPayment',
  components: {
    PaymentStatus,
  },
  props: {},
  data() {
    return {
      title: this.$translate('ONE_MOMENT'),
      message: this.$translate('WAITING_PAYMENT_PROCESS'),
      positiveBtnText: '',
      negativeBtnText: '',
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onStatusChange(status) {
      this.positiveBtnText = '';
      this.negativeBtnText = '';

      if (status === 'WaitingForPayment') {
        this.title = this.$translate('ONE_MOMENT');
        this.message = this.$translate('WAITING_PAYMENT_PROCESS');
      } else if (status === 'Confirmed') {
        this.title = this.$translate('PAYMENT_RECEIVED');
        this.message = this.$translate('SUBSCRIPTION_PAYMENT_SUCCESS_MSG');
        this.positiveBtnText = this.$translate('GO_TO_SUBSCRIPTION');
        this.negativeBtnText = this.$translate('BACK_HOME_PAGE');
      } else {
        this.title = this.$translate('PAYMENT_FAILED');
        this.message = this.$translate('SUBSCRIPTION_PAYMENT_ERROR_MSG');
        this.negativeBtnText = this.$translate('BACK_HOME_PAGE');
      }

      // Clear current data saved in subscription store module
      this.$store.commit('subscription/clear');
    },
    onPositiveBtnClick() {
      // Go to subscription
      this.goToHomePage();
      window.EventBus.fire('openShoppingListDialog', true);
    },
    onNegativeBtnClick() {
      // Go to home page
      this.goToHomePage();
    },
    goToHomePage() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
  },
};
</script>
